import { Button } from "@material-tailwind/react";
import { updateDashboard } from "../../api/api";
import { useState } from "react";

const DashboardUpdateModal = ({ token, name, onClose, onRename }) => {
  const [newName, setNewName] = useState(name);

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const handleUpdate = async () => {
    try {
      await updateDashboard(token, newName);
      onRename(newName);
      onClose();
    } catch (err) {
      console.error("Failed to update dashboard name:", err);
    }
  };

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50"
      onClick={handleOverlayClick}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg w-full max-w-md">
        <h2 className="text-xl font-semibold mb-4">Rename Dashboard</h2>
        <input
          type="text"
          value={newName}
          onChange={(e) => setNewName(e.target.value)}
          placeholder="Enter new name"
          className="w-full px-3 py-2 border rounded mb-4"
        />
        <div className="flex justify-end space-x-2">
          <Button className="bg-gray-300 text-gray-800" onClick={onClose}>
            Cancel
          </Button>
          <Button className="bg-delft-blue text-white" onClick={handleUpdate}>
            Save
          </Button>
        </div>
      </div>
    </div>
  );
};

export default DashboardUpdateModal;
